module.exports = __webpack_public_path__ + "img/66.6.CODm.3a0b720b.png";